import * as React from "react";
import SvgIcon from "@material-ui/core/SvgIcon";

const SvgI24Restriction = props => {
  return (
    <SvgIcon {...props}>
      <path d="M12,2A10,10,0,1,0,22,12,10,10,0,0,0,12,2Zm0,18a8,8,0,0,1-8-8A7.92,7.92,0,0,1,5.69,7.1L16.9,18.31A7.92,7.92,0,0,1,12,20Zm6.31-3.1L7.1,5.69A7.92,7.92,0,0,1,12,4a8,8,0,0,1,8,8A7.92,7.92,0,0,1,18.31,16.9Z" />
    </SvgIcon>
  );
};

export default SvgI24Restriction;
